document.addEventListener("DOMContentLoaded", () => {
  const collectionWrappers = document.querySelectorAll(".collection-wrapper");

  const formatNumber = (number) => {
    return number < 10 ? "0" + number : number;
  };

  collectionWrappers.forEach((wrapper) => {
    const imageSwiperEl = wrapper.querySelector(
      '[class*="collection-swiper-"]',
    );
    const textSwiperEl = wrapper.querySelector(".collection-text");
    const currentSlideEl = wrapper.querySelector(".current-slide");

    if (!imageSwiperEl || !textSwiperEl) return;

    const updateCounter = (swiper) => {
      if (!currentSlideEl) return;

      const current = formatNumber(swiper.activeIndex + 1);
      const total = formatNumber(swiper.slides.length);

      currentSlideEl.textContent = `${current} / ${total}`;
    };

    const textSwiper = new Swiper(textSwiperEl, {
      speed: 0,
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });

    const imageSwiper = new Swiper(imageSwiperEl, {
      speed: 300,
      slidesPerView: 1,
      loop: false,
      grabCursor: true,

      on: {
        init() {
          updateCounter(this);
        },

        slideChange() {
          textSwiper.slideTo(this.activeIndex);
          updateCounter(this);
        },
      },
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const productGallery = document.querySelector(".product-gallery-swiper");
  const productGalleryCounter = document.querySelector(
    ".product-gallery-counter",
  );

  if (
    !productGallery ||
    !productGalleryCounter ||
    typeof Swiper === "undefined"
  )
    return;

  if (productGallery.dataset.inited === "true") return;
  productGallery.dataset.inited = "true";

  const slidesCount = productGallery.querySelectorAll(".swiper-slide").length;
  const hasOnlyOneSlide = slidesCount === 1;

  new Swiper(productGallery, {
    loop: !hasOnlyOneSlide,
    spaceBetween: 10,
    watchOverflow: true,

    slidesPerView: hasOnlyOneSlide ? 1 : 2,

    pagination: {
      el: productGalleryCounter,
      type: "fraction",

      formatFractionCurrent: function (number) {
        return number < 10 ? "0" + number : number;
      },

      formatFractionTotal: function (number) {
        return number < 10 ? "0" + number : number;
      },

      renderFraction: function (currentClass, totalClass) {
        return `
          <span class="${currentClass}"></span>
          <span class="product-gallery-counter-separator"> / </span>
          <span class="${totalClass}"></span>
        `;
      },
    },

    navigation: {
      nextEl: productGallery.querySelector(".swiper-button-next"),
      prevEl: productGallery.querySelector(".swiper-button-prev"),
    },

    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  });
});
